import { render, staticRenderFns } from "./VoucherSegmentClientListItemLogin.vue?vue&type=template&id=03ae15bb&scoped=true"
import script from "./VoucherSegmentClientListItemLogin.vue?vue&type=script&lang=js"
export * from "./VoucherSegmentClientListItemLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03ae15bb",
  null
  
)

export default component.exports